import store from '@/store'
import HSESettingsRoutes from '@/views/Project/HSE/router/hsesettings'
import PSISettingsRoutes from '@/views/Project/PSI/router/psi-settings'
const settingsRoutes = {
    path: 's',
    name: 'settings',
    meta: { title: 'project_menu.settings' },
    component: () => import('@/views/Project/Settings/Index/Index.vue'),
    beforeEnter: (to, from, next) => {
        if (store.getters.authenticated) {
            next()
        } else {
            next({ name: 'SignIn', query: { url: to.fullPath } })
        }
    },

    redirect: { name: 'project-general-settings' },
    children: [
        {
            path: 'g',
            name: 'project-general-settings',
            component: () => import('@/views/Project/Settings/General/General.vue'),
            meta: {
                title: 'project_menu.settings',
            },
        },
        HSESettingsRoutes,
        PSISettingsRoutes,

        {
            path: 'm/:projectId(\\d+)?',
            name: 'modules',
            component: () => import('@/views/Project/Settings/Modules/views/modules.vue'),
            meta: {
                title: 'project_menu.settings',
                permission: [
                    'project.manage.observation',
                    'project.manage.hse',
                    'project.manage.psi',
                ],
                requireProject: true,
            },
        },
        {
            path: 'o/:projectId(\\d+)?',
            name: 'observations-settings',
            component: () => import('@/views/Project/Settings/Observation/Index/Index.vue'),
            meta: {
                title: 'project_menu.settings',
                permission: ['observation.admin'],
                requireProject: true,
            },

            redirect: { name: 'general-observations-settings' },
            children: [
                {
                    path: 'g',
                    title: 'project_menu.settings',
                    name: 'general-observations-settings',
                    component: () =>
                        import('@/views/Project/Settings/Observation/views/General.vue'),
                    meta: {
                        title: 'project_menu.settings',
                    },
                },
                {
                    path: 'ld/:projectId(\\d+)?',
                    name: 'location-drawing-settings',
                    component: () => import('@/views/Project/Settings/views/LocationDrawing.vue'),
                    meta: {
                        title: "project_settings_menu['project.locationDrawing']",
                        permission: ['project.manage_locations'],
                        requireProject: true,
                    },
                },
                {
                    path: 'l/:projectId(\\d+)?',
                    name: 'location-settings',
                    component: () => import('@/views/Project/Settings/views/Location.vue'),
                    meta: {
                        title: 'project_menu.settings',
                        permission: ['project.manage_locations'],
                        requireProject: true,
                    },
                },
                {
                    path: 'cat',
                    name: 'categories-observations-settings',
                    component: () =>
                        import('@/views/Project/Settings/Observation/views/Category.vue'),
                    meta: {
                        title: 'project_menu.settings',
                    },
                },
                {
                    path: 'cau',
                    name: 'causes-observations-settings',
                    component: () => import('@/views/Project/Settings/Observation/views/Cause.vue'),
                    meta: {
                        title: 'project_menu.settings',
                        header: true,
                    },
                },
                {
                    path: 'ru',
                    name: 'responsible-users-settings',
                    component: () =>
                        import('@/views/Project/Settings/Observation/ResponsibleUser.vue'),
                    meta: {
                        title: 'project_menu.settings',
                        header: true,
                    },
                },
            ],
        },

        {
            path: 'u/:projectId(\\d+)?',
            name: 'users-settings',
            component: () => import('@/views/Authorization/views/UsersSettings/UsersSettings.vue'),
            meta: {
                permission: ['authorization.manage_access', 'authorization.delegate_access'],
                requireProject: true,
                title: 'project_menu.settings',
            },
        },

        {
            path: 'r/:projectId(\\d+)?',
            name: 'roles-setting',
            component: () => import('@/views/Authorization/views/RolesSettings/RolesSettings.vue'),
            meta: {
                title: 'project_menu.settings',
                permission: ['authorization.manage_access'],
                requireProject: true,
            },
        },
        // contractor settings
        {
            path: 'ch',
            name: 'contractors',
            component: () => import('@/views/Project/Settings/ch/index.vue'),
            redirect: { name: 'contractors-general-settings' },
            children: [
                {
                    path: 'forms',
                    name: 'contractors-forms',
                    meta: {
                        title: 'project_menu.contractors',
                    },
                    component: () => import('@/views/Project/Settings/ch/forms.vue'),
                },
                {
                    path: 'general',
                    name: 'general-contractors-settings',
                    meta: {
                        title: 'project_menu.contractors',
                    },
                    component: () => import('@/views/Project/Settings/ch/general.vue'),
                },
                {
                    path: 'workAlert',
                    name: 'alert-contractors-settings',
                    meta: {
                        title: 'project_menu.contractors',
                    },
                    component: () => import('@/views/Project/Settings/ch/workAlert.vue'),
                },
            ],
        },
        // courses settings
        {
            path: 'courses',
            name: 'settings-course',
            component: () => import('@/views/Project/Settings/courses/index.vue'),
            redirect: { name: 'courses-settings-general' },
            children: [
                {
                    name: 'courses-settings-general',
                    path: 'courses-general',
                    meta: {
                        title: 'project_menu.course',
                    },
                    component: () => import('@/views/Project/Settings/courses/general.vue'),
                },
                {
                    name: 'courses-settings-all-courses',
                    path: 'all-courses',
                    meta: {
                        title: 'project_menu.course',
                    },
                    component: () => import('@/views/Project/Settings/courses/items.vue'),
                },
            ],
        },
        // access settings
        {
            path: 'ac',
            name: 'settings-access',
            component: () => import('@/views/Project/Settings/access/index.vue'),
            redirect: { name: 'access-settings-general' },
            children: [
                {
                    name: 'access-settings-general',
                    path: 'g',
                    meta: {
                        title: 'project_menu.access_control',
                    },
                    component: () => import('@/views/Project/Settings/access/general.vue'),
                },
                {
                    name: 'access-settings-readers',
                    path: 'r',
                    meta: {
                        title: 'project_menu.access_control',
                    },
                    component: () => import('@/views/Project/Settings/access/readers.vue'),
                },
                {
                    name: 'access-settings-rules',
                    path: 're',
                    meta: {
                        title: 'project_menu.access_control',
                    },
                    component: () => import('@/views/Project/Settings/access/rules.vue'),
                },
                {
                    name: 'access-settings-groups',
                    path: 'gr',
                    meta: {
                        title: 'project_menu.access_control',
                    },
                    component: () => import('@/views/Project/Settings/access/groups.vue'),
                },
            ],
        },
    ],
}

export default settingsRoutes
